import { SUBSCRIPTION_LEVELS } from '../../account/constants';
import config from '../../config';

import purchaseButtonUrl from './purchasePremiumButtonComponent.html';

class PurchaseButtonController {
  availableLevels = Object.values(SUBSCRIPTION_LEVELS).map(Number).sort();
  TOAST_SALES_URL = config.TOAST_SALES_URL;
  constructor(Authentication, AccountService, $state) {
    'ngInject';

    Object.assign(this, { Authentication, AccountService, $state });
  }

  get neededPlan() {
    const level = this.Authentication.user.orgSettings.premiumFeatures[this.feature] || 0;
    return this.availableLevels.find((availableLevel) => availableLevel >= level);
  }

  upgradeToBusiness() {
    this.buyCallback?.();
    this.$state.go('account.overview.billing');
  }

  startTrial() {
    this.buyCallback?.();
    this.AccountService.startTrial();
  }

  purchasePlan() {
    this.buyCallback?.();
    this.$state.go('account.overview.purchase', { plan: this.neededPlan });
  }
}

export default {
  controllerAs: 'ctrl',
  controller: PurchaseButtonController,
  templateUrl: purchaseButtonUrl,
  bindings: {
    feature: '@',
    buyCallback: '&?',
    fromCustomerReviews: '<?',
  },
};
